"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRebalanceHistory = getRebalanceHistory;
exports.getRebalanceHistories = getRebalanceHistories;
const fetchRebalanceEvents_js_1 = require("./sui-sdk/events/fetchRebalanceEvents.js");
async function getRebalanceHistory(poolName) {
    const historyMap = await getRebalanceHistories([poolName]);
    const history = historyMap[poolName];
    if (history === undefined)
        return [];
    return history;
}
async function getRebalanceHistories(poolNames) {
    const endTime = Date.now();
    const startTime = endTime - 24 * 60 * 60 * 1000 * 30; // timestamp for 1 month ago
    const events = await (0, fetchRebalanceEvents_js_1.fetchRebalanceEvents)({
        startTime: startTime,
        endTime: endTime,
        poolNames: poolNames,
    });
    const rebalanceHistoryMap = await (0, fetchRebalanceEvents_js_1.calculateRebalanceHistoryFromEvents)(events);
    return rebalanceHistoryMap;
}
//# sourceMappingURL=getRebalanceHistory.js.map